<wiz-hgroup #argContainer width="100%" height="100%">
  
  <wiz-hgroup #lbl *ngIf="uselbl" width="100%" height="100%"><!-- rendu d'un média du FDV-->
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-label id="label"
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
      <wiz-label id="inzone" 
      [wizLabel]="formatedValue"
      width="100%"
      ></wiz-label>
    </wiz-vgroup>
  </wiz-hgroup>


  <wiz-hgroup #imgGp *ngIf="useimgGp"  width="100%" height="100%"><!-- rendu d'un média du FDV-->
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-label #imgLbl id="label"    
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
      <wiz-image
        #img
        wizholdable
        tabindex="0"
        height="100%"
        width="100%"
        class="img-freestyle"
        [blobid]="imgBlobid"
        [sourceObservable]="imgSrcObs"
        (wizHold)="seeImage($event)"
      ></wiz-image>
    </wiz-vgroup>
  </wiz-hgroup>

  <wiz-button #bt *ngIf="usebt" 
  class="button-connect"
  [wizLabel]="cnx?.trsLabel"
  [tooltipText]="cnx?.trsDescription"
  [wizImage]="cnx?.iconOrDie"
  width="100%" (wizClick)="doArgAction()"></wiz-button>

  <!-- html libre -->
  <wiz-hgroup #freeGrp [visible]="usefreeGrp"  width="100%" height="100%">
    <angular-editor #ae width="100%" height="100%" style="pointer-events: none;"></angular-editor>
  </wiz-hgroup>
  
  <!-- image libre Embedded (en cache) -->
  <wiz-hgroup #freeImgGrp *ngIf="usefreeImgGrp" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [sourceObservable]="imgSrcObs"
        #freeImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <!-- rendu lien hypertexte sur un texte -->
  <wiz-hgroup #linkGp *ngIf="uselinkGp" width="100%" height="100%"> <!-- rendu texte du FDV au format hyperText-->
    <div><a href="{{linkUrl}}" target="_blank">{{linkLabel}}</a></div>
  </wiz-hgroup>

  <!-- rendu de type "media" sur un texte -->
  <wiz-hgroup #mediaGrp *ngIf="usemedia" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [source]="formatedValue"
        #mediaImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>
  
  <wiz-checkbox #cb *ngIf="usecb" [ngClass]="injectClass" 
    [wizLabel]="alternateLabel"
    [wizValue]="formatedValue"
    [wizDisabled]=true
    [wizShowLabel]="showLabel"></wiz-checkbox>

  <wiz-vgroup *ngIf="usecolor" width="100%" height="100%" [ngClass]="injectClass">
    <wiz-label #colorLbl id="label" 
    [wizLabel]="alternateLabel"
    class="componentLabel" 
    [visible]="showLabel"></wiz-label>
      <span
        #cellBlockBack
        [style.backgroundColor]="formatedValue"
        width="20px"
        height="20px"
        style="border-radius: 20px; border-style: solid; border-width: 1px"
      ></span>
  </wiz-vgroup>

  <!-- workflow -->
  <wiz-vgroup #workflowGroup *ngIf="useworkflow" width="100%" height="100%" [ngClass]="injectClass">
      <wiz-label #colorLbl id="label" 
      [wizLabel]="alternateLabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
    <wiz-hgroup width="100%" height="100%" id="inzone"
      verticalAlign="center">
          
        <wiz-image *ngIf="!!workImageBlob"
        class="img-freestyle"
        [sourceObservable]="workImage"
        #workImg
        tabindex="0"
        height="90%"
        style="aspect-ratio: 1;"
        ></wiz-image>   
      
      <wiz-icon class="image-purple" *ngIf="!!workIcon">
          <mat-icon>{{workIcon}}</mat-icon></wiz-icon>
        
         <wiz-vgroup width="100%" height="100%" horizontalAlign="center" verticalAlign="center" style="padding-right: 5px;">     
          <wiz-hgroup width="100%" verticalAlign="center" style="overflow-y: auto;">
              <span class="wiz-cell-text" >{{workflowLabel}}</span>
          </wiz-hgroup>  

          <!-- pièce jointe -->
          <wiz-hgroup #dropFull class="dropZone" *ngIf="workFile" 
                horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
                width="100%" height="30px">
                  <wiz-label [wizLabel]="workFile?.shortFileName" [wizTooltip]="workFile.fileName" width="100%"
                  style="word-break: break-all;"></wiz-label>
                  <wiz-vgroup width="28px">  
                    <wiz-icon #icoLoadWorkFile 
                    [undisableable]="true"
                    style="cursor: pointer; font-size: 20px" (click)="loadDropWorkFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
                  </wiz-vgroup>
                </wiz-hgroup>
        
         </wiz-vgroup>

     </wiz-hgroup>
  </wiz-vgroup>

  <!-- rendu liste de sous-éléments -->
  <wiz-hgroup #listGP *ngIf="uselistGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-label #listLbl class="componentLabel" id="label" 
      [wizLabel]="alternateLabel"
      [visible]="showLabel"></wiz-label>
      <div innerHTML="{{ formatedValue }}" id="inzone"></div>
    </wiz-vgroup>  
  </wiz-hgroup>


</wiz-hgroup>
